import React, {useContext, useState} from 'react';
import { IStory } from '../../../interfaces/story';
import default_avatar from "../../../assets/images/default-avatar.jpg";
import moment from "moment";
import { useNavigate } from 'react-router-dom';
import { IUserDetails } from '../../../interfaces/authentication';
import TooltipHelp from '../../notifications/tooltiphelp.component';
import blue_flag from '../../../assets/images/bg-flag-blue.svg'
import { dateFormat } from '../../../_helper/enum/enum';
import { Spinner } from 'react-bootstrap';
import { Context } from '../../../pages/home.page';
import DemoNotification from '../../notifications/demo.notification.component';
import { useTranslation } from 'react-i18next';

interface IProps {
    data: IStory[]
    loaded: boolean
}

const renewTooltip = (t: any) => ({
    title: t("What's this?"),
    subtitle: t("Republish pending"),
    text: () => (
        <div style={{textAlign:'center'}}>
            <p className="subtitle">
                <img alt="flag" src={blue_flag}/>
            </p>
            <p>{t("This published story has author updates that are not visible to viewers. Finish your editing and Republish (on Step 3) to make the changes live.")}</p>
        </div>
    ),
})

/**
 * Create story page
 * 
 * @param props : props
 * @returns void
 */
export default function EditedStories(props: IProps) {
    const navigate = useNavigate();
    const [showRenew, setShowRenew] = useState<boolean>(false);

    const demo = useContext(Context).demo;

    const { t } = useTranslation();    

    function navigateTo(story: IStory) {
        navigate('/dashboard/create', { state: { data: story } });
    }

    return (
        <div className="unpublished-stories">
            {props.data.length ? <p className="information">{props.data.length} {t("stories to be published")}</p> : props.loaded ? <p className="information">{t("There are no story awaiting publication")}</p> :
                <div className="spinner-container">
                    <Spinner animation="border" variant="#fff" />
                </div>}
            {props.data.sort((a, b) => { return new Date(b.updatedAt).valueOf() - new Date(a.updatedAt).valueOf() }).map((story: IStory, index) => {
                const author = (story.author as IUserDetails)
                const avatar = author.avatar ? author.avatar : default_avatar;

                return (
                    <div className="up-story" onClick={() => demo ? null : navigateTo(story)} key={index}>
                        <p className="story-title">{story.title ? story.title : t("Untitled")}</p>
                        <img className="user-picture" alt="profile-avatar" src={avatar} />
                        <p className="author">{(story.author as IUserDetails).firstname}</p>

                        {story.published && story.edited ?
                            <div className="flair" onClick={(e) => {e.stopPropagation();setShowRenew(true)}}>
                                <img alt="flag" src={blue_flag} />
                            </div>
                            : null}

                        <p className="last-modified">{moment(story.updatedAt).format(dateFormat.SHORT)}</p>

                    </div>
                )
            })}

            {demo && <DemoNotification />}

            <TooltipHelp
                title={renewTooltip(t).title}
                subtitle={renewTooltip(t).subtitle}
                text={renewTooltip(t).text}
                show={showRenew}
                clear={() => setShowRenew(false)}
            />
        </div>
    );
};